import React from 'react';

//Interface
import AllocationsCheck, { defaultConfigComponent as ALConfigComponent } from '@pages/DataBase/AllocationCheck/AllocationsCheck';

import { CEntity, IForm } from '@ts/ui-models';
import { IEntity } from '@ts/ui-models';

interface AuditProp extends IForm {}

const AuditTab: React.FC<AuditProp> = props => {
  const crudItem: CEntity<IEntity> = new CEntity<IEntity>(props.values);

  return <AllocationsCheck configComponent={{ ...ALConfigComponent, filtersFetchData: { locationId: crudItem.getID() } }} />;
};

export default AuditTab;
